export default __webpack_public_path__ + "b0b8b1b02ecbfd6c59d80c9aaaebfa8d.svg";